export default __webpack_public_path__ + "static/media/deliveries_10.0fe6a1d3.png";